import { Routes } from '@common/constants';
import { SearchFlow } from '@features/Home/SearchFlow';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useTranslations } from '@lang';
import * as entityActions from '@store/entity/actions';
import { NormalizedStore } from '@store/entity/entity.types';
import { NextPage, NextPageContext } from 'next';
import Head from 'next/head';
import { useEffect } from 'react';
import { useRouter } from 'shared-routing';
import { Property } from 'shared-types/Property';

type SearchPageProps = {
  property: Property;
  language: string;
  url: string;
};

const SearchPage: NextPage<SearchPageProps> = ({ property, language }) => {
  const { t } = useTranslations();
  const router = useRouter();
  const isEcom2 = useFeatureIsOn('feature.ecom2');

  useEffect(() => {
    if (!isEcom2) router.push({ pathname: Routes.HOME });
  }, [isEcom2, router]);

  const pageName = t('common.search');
  const pageTitle = property.propertyTitle ? `${pageName} | ${property.propertyTitle}` : pageName;

  if (!isEcom2) return null;

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
      </Head>
      <SearchFlow property={property} language={language} />
    </>
  );
};

type SearchPageInitialProps = {
  store: NormalizedStore;
  property: Property;
  language: string;
  url: string;
} & NextPageContext;

SearchPage.getInitialProps = async ({
  store,
  property,
  language,
  url,
}: SearchPageInitialProps): Promise<SearchPageProps> => {
  if (property.homepage) {
    await store.dispatch(entityActions.fetchHomepage(property.id, language));
  }

  return { property, language, url };
};

export default SearchPage;
